import axios from "@/api/axios";

import { DefaultService } from "./DefaultService";
import { ClinicInterface } from "@/api/Interfaces/ClinicInterface";

export default class Clinic extends DefaultService {
  url = "clinics/";

  store(): Promise<ClinicInterface> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.url}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getClinicsWithAddress(clinicId: any): Promise<ClinicInterface> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.url}${clinicId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
